// Check the number of items in tabpanel, if 1 item add a class
const wedoxaBlock = document.querySelector('.wedoxa-tabs');

if (wedoxaBlock) {
  const tabs = wedoxaBlock.querySelectorAll('.tabs-block__tabpanel');

  tabs.forEach(tab => {
    const tabPanelItems = tab.querySelectorAll('.tabpanel-item');

    const count = tabPanelItems.length;

    if(count == 1) {
      tab.classList.add('one-item');
    }
  });
}